import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CommentCollection } from '../index'

export const setupCommentReplication = (
  collection: CommentCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'comments',
    displayName: 'Comment',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      content: doc.content,
      contentFormat: doc.contentFormat || 'tiptap',
      contentPlainText: doc.contentPlainText,
      parentCommentId: doc.parentCommentId,
      anchorId: doc.anchorId ?? null,
      isDeleted: doc.isDeleted || false,
      isResolved: doc.isResolved || false,
      resolvedAt: doc.resolvedOn ? (toTimestamp(doc.resolvedOn) ?? new Date(doc.resolvedOn).getTime()) : null,
      resolvedBy: doc.resolvedBy ?? null,
      createdByName: doc.createdByName ?? null,
      createdByEmail: doc.createdByEmail ?? null,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      entityType: state.entityType,
      entityId: state.entityId,
      content: state.content,
      contentFormat: state.contentFormat,
      contentPlainText: state.contentPlainText,
      parentCommentId: state.parentCommentId,
      anchorId: state.anchorId ?? null,
      isDeleted: state.isDeleted,
      isResolved: state.isResolved ?? false,
      resolvedOn: toISOStringOrNull(state.resolvedAt),
      resolvedBy: state.resolvedBy ?? null,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
